import type { IntlShape } from 'react-intl';

export function getRetargetingEventLabel(formatMessage: IntlShape['formatMessage'], event: string): string {
  return formatMessage({
    defaultMessage: event === 'show' ? 'Impressions' : event,
    id: `targeting.audienceTargeting.audienceProfile.campaignEvents.events.cpyStatsName${event}`
  });
}
